export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = 4